module.exports = __webpack_public_path__ + "img/9788966186808.c1146bba.jpg";